<template>
  <div class="buy">
    <el-table :data="tableData" border stripe>
      <el-table-column
        prop="createAt"
        label="时间"
        width="107"
      ></el-table-column>
      <el-table-column prop="name" label="订单名称" width="550">
        <template #default="scope">
          <span v-show="scope.row.leID">
            <RouterLink
              :to="`/video/videodetail?clID=${scope.row.clID}&id=${scope.row.leID}`"
            >
              {{ scope.row.name }}
            </RouterLink>
          </span>
          <span v-show="scope.row.testsID">
            <RouterLink
              :to="`/tests/testsdetail?clID=${scope.row.clID}&id=${scope.row.testsID}`"
            >
              {{ scope.row.name }}
            </RouterLink>
          </span>
          <span v-show="scope.row.booksID">
            <RouterLink
              :to="`/books/booksdetail?clID=${scope.row.clID}&id=${scope.row.booksID}`"
            >
              {{ scope.row.name }}
            </RouterLink>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="类型" width="75">
        <template #default="scope">
          <span v-show="scope.row.leID">
            <RouterLink
              :to="`/video/videodetail?clID=${scope.row.clID}&id=${scope.row.leID}`"
            >
              <el-tag type="success" style="margin: 3px">视频</el-tag>
            </RouterLink>
          </span>
          <span v-show="scope.row.testsID">
            <RouterLink
              :to="`/tests/testsdetail?clID=${scope.row.clID}&id=${scope.row.testsID}`"
            >
              <el-tag type="success" style="margin: 3px">题库</el-tag>
            </RouterLink>
          </span>
          <span v-show="scope.row.booksID">
            <RouterLink
              :to="`/books/booksdetail?clID=${scope.row.clID}&id=${scope.row.booksID}`"
            >
              <el-tag type="success" style="margin: 3px">图书</el-tag>
            </RouterLink>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="shclass" label="专业" width="200">
        <template #default="scope">
          <span v-for="item in scope.row.shclass" :key="item.index">
            <el-tag style="margin: 3px">{{ item.clName }}</el-tag>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="salePrice" label="金额" width="60" />
      <el-table-column prop="payed" label="状态" width="120">
        <template #default="scope">
          <span v-show="scope.row.payed == true">
            <el-tag style="margin: 3px">已支付</el-tag>
          </span>
          <span v-show="scope.row.payed == false">
            <el-tag type="warning" style="margin: 3px">未支付</el-tag>
            <el-tag
              v-show="scope.row.dateDifference > 2"
              type="danger"
              style="margin: 3px"
              >订单已过期</el-tag
            >
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="payed" label="操作">
        <template #default="scope">
          <span
            v-show="scope.row.payed == false && scope.row.dateDifference <= 2"
          >
            <RouterLink :to="`/user/pay?orderID=${scope.row.orderID}`">
              <el-button type="primary">去支付</el-button>
            </RouterLink>
          </span>
          <span
            v-show="
              scope.row.payed == false &&
              scope.row.dateDifference > 2 &&
              scope.row.leID
            "
          >
            <RouterLink
              :to="`/user/checkout?clID=${scope.row.clID}&id=${scope.row.leID}&type=video`"
            >
              <el-button type="danger" plain>重新下单</el-button>
            </RouterLink>
          </span>
          <span
            v-show="
              scope.row.payed == false &&
              scope.row.dateDifference > 2 &&
              scope.row.booksID
            "
          >
            <RouterLink
              :to="`/books/booksdetail?clID=${scope.row.clID}&id=${scope.row.booksID}`"
            >
              <el-button type="danger" plain>重新下单</el-button>
            </RouterLink>
          </span>
          <span
            v-show="
              scope.row.payed == false &&
              scope.row.dateDifference > 2 &&
              scope.row.testsID
            "
          >
            <RouterLink
              :to="`/user/checkout?clID=${scope.row.clID}&id=${scope.row.testsID}&type=tests`"
            >
              <el-button type="danger" plain>重新下单</el-button>
            </RouterLink>
          </span>
          <el-button @click="cancelOrder(scope.row.orderID)"
            >删除订单</el-button
          >
          <span v-show="scope.row.payed">
            <RouterLink :to="`/user/pay?orderID=${scope.row.orderID}`">
              <el-button type="success" plain>支付成功</el-button>
            </RouterLink>
          </span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { ref } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { delOrder } from "@/api/order";
export default {
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const route = useRoute();
    const store = useStore();

    const cancelOrder = (orderID) => {
      delOrder(orderID).then((data) => {
        console.log(data);
      });
    };
    return { cancelOrder };
  },
};
</script>

<style lang="less" scoped>
.buy {
  margin: 8px 8px 8px 8px;
  a {
    &:hover {
      color: @shColor;
    }
  }
}
</style>
